module.exports = __webpack_public_path__ + "static/media/3dbazaar_logo_text_filled.eab747bd.svg";